import React, { useState } from "react";
import styled from "styled-components";
import AppSmallButton from "../appComponents/UtilsComponents/AppSmallButton";
import { useAppSelector, useAppDispatch } from "../../Store";
import { useBotConfigStore } from "../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { Typography } from "@mui/material";
import  TempLogo  from "../../assets/images/startscreenlogo.png";
import { useSelector } from "react-redux";
import { botInfoStore } from "../../Store/Slices/socket/BotInfoSlice";

interface StartScreenProps {
  onComplete: () => void;

}

const StartScreen: React.FC<StartScreenProps> = ({ onComplete }) => {
  const { botConfig } = useAppSelector(useBotConfigStore);
  const [showForm, setShowForm] = useState(false);
  const { isBotSetToFullScreen } = useSelector(botInfoStore);
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: ""
  });
  const [errors, setErrors] = useState({
    email: "",
    name: "",
    phone: ""
  });

  const validateForm = () => {
    const newErrors = {
      email: "",
      name: "",
      phone: ""
    };
    let isValid = true;

    if (botConfig?.config?.start_screen?.form?.name && !formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    if (botConfig?.config?.start_screen?.form?.email && !formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    if (botConfig?.config?.start_screen?.form?.phone && !formData.phone.trim()) {
      newErrors.phone = "Phone is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onComplete();
    }
  };



  const startScreenConfig = botConfig?.config?.start_screen;

  const ResponsiveTypography = styled(Typography)`
    && {
      font-size: 2vw;
      @media (min-width: 1200px) {
        font-size: 24px;
      }
      @media (max-width: 768px) {
        font-size: 16px;
      }
      @media (max-width: 480px) {
        font-size: 14px;
      }
    }
  `;

  const ResponsiveTitle = styled(Typography)`
    && {
      font-size: 2.5vw;
      @media (min-width: 1200px) {
        font-size: 28px;
      }
      @media (max-width: 768px) {
        font-size: 20px;
      }
      @media (max-width: 480px) {
        font-size: 16px;
      }
    }
  `;

  return (
    <StyledStartScreenWrapper style={showForm ? {justifyContent: "flex-start"} : {}}>
      {!showForm ? (
        <StyledInitialView>
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", height: "75%", gap: "20px"}}>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <img src={TempLogo} alt="Start Screen" width={isBotSetToFullScreen ? 300 : 160} height={isBotSetToFullScreen ? 300 : 160} />
              
              {startScreenConfig?.title && 
              <ResponsiveTypography textAlign="center" variant="body1" style={{ maxWidth: isBotSetToFullScreen ? '60%' : '100%' }}>
                {startScreenConfig?.title}
              </ResponsiveTypography>}
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

            {startScreenConfig?.start_chat_button && (
              <AppSmallButton style={{width: '100%', borderRadius: '16px'}} onClick={() => setShowForm(true)}>
              {startScreenConfig.start_chat_button.text || "Start Chat"}
            </AppSmallButton>
          )}
          </div>
          </div>
          
          
        </StyledInitialView>
      ) : (
        <>
         <div style={{ display: "flex", alignItems: "center", flexDirection: "column", width: "100%" }}>
                <img src={TempLogo} alt="Start Screen" width={160} height={160} />

                {startScreenConfig?.form?.form_title && 
              <ResponsiveTitle textAlign="center" variant="h6" fontWeight={'bold'}>
                {startScreenConfig?.form?.form_title}
              </ResponsiveTitle>}
              
              {startScreenConfig?.form?.form_description && 
              <ResponsiveTypography textAlign="center" variant="body1" style={{ maxWidth: isBotSetToFullScreen ? '48%' : '70%' }}>
                {startScreenConfig?.form?.form_description}
              </ResponsiveTypography>}
            </div>
        
        
        
        <StyledForm onSubmit={handleSubmit}>

         
        
          {startScreenConfig?.form?.name && (
            <StyledInputWrapper>
              <StyledInput
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                hasError={!!errors.name}
              />
              {/* {errors.name && <StyledError>{errors.name}</StyledError>} */}
            </StyledInputWrapper>
          )}

          {startScreenConfig?.form?.email && (
            <StyledInputWrapper>
              <StyledInput
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                hasError={!!errors.email}
              />
              {/* {errors.email && <StyledError>{errors.email}</StyledError>} */}
            </StyledInputWrapper>
          )}

          {startScreenConfig?.form?.phone && (
            <StyledInputWrapper>
              <StyledInput
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleInputChange}
                hasError={!!errors.phone}
              />
              {/* {errors.phone && <StyledError>{errors.phone}</StyledError>} */}
            </StyledInputWrapper>
          )}
          
          {startScreenConfig?.form?.submit_button && (
            <AppSmallButton  type="submit">
              {startScreenConfig.form.submit_button.text || "Submit"}
            </AppSmallButton>
          )}
        </StyledForm>
        </>
      )}
    </StyledStartScreenWrapper>
  );
};

export default StartScreen;

const StyledStartScreenWrapper = styled.div`
  
  width: 100%;
  height: calc(100vh - 110px);
  position: absolute;
  // border-radius: 10px;
  bottom: 24px;
  left: 0;
  background-color: #F4FAFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  z-index: 1000;
`;

const StyledInitialView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  height: 100%;
  padding: 20px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 80%;
  max-width: 600px;
`;

const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledInput = styled.input<{ hasError: boolean }>`
  padding: 12px;
  border: 1px solid ${props => props.hasError ? '#ff0000' : '#ddd'};
  border-radius: 4px;
  font-size: 14px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#ff0000' : '#007bff'};
  }
`;


